module.exports = __webpack_public_path__ + "media/theme/step--1-e7d76338.png";